import useSWR from 'swr';
import { CheckoutMapSettingsItem } from '../model/CheckoutMapSettings';
import { useAppSelector } from 'redux/hooks';
import swrConfig from 'utils/swrConfig';
import { getCheckoutMapSettings } from 'services/settings/ppoints/CheckoutMapSettings';

const useCheckoutMapSettingsSWR = () => {
    const ecoms = useAppSelector((state) => state.ecoms);

    const fetcher = (): Promise<CheckoutMapSettingsItem[]> => {
        if (!ecoms?.selected?.id) {
            return Promise.reject(new Error('Ecom not selected'));
        }
        return getCheckoutMapSettings(ecoms?.selected?.id);
    };

    const { data, error, isLoading, mutate } = useSWR('checkout-map-settings', fetcher, swrConfig);

    return { data, error, isLoading, mutate };
};

export default useCheckoutMapSettingsSWR;
